{
  "0031ddd1d1262240": "Transfer DNRs between workplaces",
  "01d8efda72cd3d07": "Reason for deletion",
  "0896420838398301": "The source workplace has no DNRs to copy.",
  "09fd2948a8dffd21": "Workplace",
  "10d20e340181a52f": "Select all that apply",
  "12d9815fef885712": "Source workplace",
  "155f816c0407310c": "Submit",
  "19766ed6ccb2f4a3": "Cancel",
  "1f788a0ac35935a7": "Search source workplace",
  "24fea1562512ef18": "DNR List",
  "29e53f7f6b5bff7d": "Source and target workplaces must be different.",
  "322d9f6cd4c0ce6a": "Target workplace",
  "38c1d970ac4a549b": "Unknown workplace",
  "39086c62b8953f38": "Reasons:",
  "3eea447b9a0f6500": "Copy all DNRs from a source workplace to a target workplace. Workers already DNR'd at the target workplace will be skipped.",
  "4aadd98175f7d02c": "Add DNR",
  "4b8e893689d8dc65": "Search target workplace",
  "6031ee797185af1e": "Start typing workplace name...",
  "6feb9cfbce4c4fb9": "Select a workplace to add to the DNR list for this worker.",
  "712da63171e0c9de": "Unblock",
  "72ed245d2cf11822": "Reasons",
  "8a7525b1492fb848": "Notes",
  "95a1a159ad1b6bb7": "Enter reason for deletion...",
  "9688369e4a3c1d45": "Failed to load DNR data. Please try again.",
  "9acd5ca87a2df72c": "Added {{createdDate}}",
  "9f90b6a53e10a134": "Failed to delete DNR record",
  "b3122b441bb9c72b": "Delete this DNR record?",
  "b75b00f46e72dc5e": "Recorded By",
  "c7ee9ee512665837": "Delete DNR",
  "c9eea6fa483c8dec": "Delete DNR record",
  "cc2111dd92b635db": "Searching workplaces...",
  "d515313ac37e7359": "DNR record deleted",
  "da4f7ea58d963b1a": "Notes:",
  "de5541d57b4ee198": "This entry will be permanently removed and the worker can be matched with this workplace again.",
  "de98a1aeef07296d": "Enter additional notes...",
  "e2d0a54968ead24e": "Delete",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ebe8d8f42b26353a": "Sort by {{columnLabel}}, currently {{sortState}}",
  "f30d0fbd79351450": "No DNR records found for this worker",
  "f81ab834de5f8491": "Reason",
  "ffb2623aad3197de": "Date Created"
}
